module.exports = __webpack_public_path__ + "-/media/Project/Hyland/Common/images/solution-builder/img/ins-complete-view-ebook-thumbnail.png";